module.exports = __webpack_public_path__ + "img/18.1a4d4298.png";